import { useEffect, useRef } from 'react';
import { useCrossFlow, type Options, type OptionsV1 } from '@atlassiansox/cross-flow-api-internals';
import { type ConsumerProps } from './types';

export const CrossFlowConsumer = (props: (Options | OptionsV1) & ConsumerProps) => {
	// Using useRef here to ensure that only the initial props are used
	// and it ensures that the useEffect handler below is only run once.
	// Any subsequent changes to props have no effect.
	const propsRef = useRef(props);
	const crossFlowRef = useRef(useCrossFlow());

	useEffect(() => {
		const crossFlow = crossFlowRef.current;

		(async () => {
			const { onComplete, onError, ...options } = propsRef.current;
			if (crossFlow.isEnabled) {
				const api = 'v1' in options ? crossFlow.apiV1 : crossFlow.api;
				try {
					// @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
					const status = await api.open(options);
					onComplete?.(status);
				} catch (err) {
					onError?.(err);
				}
			}
		})();
	}, []);

	return null;
};
